import * as jQuery from 'jquery';

import { IDAL } from './../services/IDAL';

export interface IDeviceInfo {
    isTouchDevice: boolean;
    platform: Platform;
    os: OS
}

export enum Platform {
    Unknown,
    Browser,
    Cordova,
    Electron
}

export enum OS {
    Unknown,

    Android,
    Linux,
    MacOS,
    iOs,
    Windows,
    WindowsMobile
}

const cordova = (<any>window).cordova || null;
const electron = <IDAL>(<any>window).electron || null;

class DeviceUtils {
    private deviceReadyPromise: Promise<IDeviceInfo>;

    constructor() {
        this.deviceReadyPromise = new Promise<IDeviceInfo>((resolve, reject) => {
            cordova ? document.addEventListener("deviceready", () => resolve(this.getDeviceInfo()), false)
                : jQuery(document).ready(() => resolve(this.getDeviceInfo()));
        });
    }

    public loadDeviceInfo(): Promise<IDeviceInfo> {
        return this.deviceReadyPromise;
    }

    private getDeviceInfo(): IDeviceInfo {
        return {
            isTouchDevice: this.isTouchDevice(),
            platform: this.getPlatform(),
            os: this.getOS()
        };
    }

    private isTouchDevice(): boolean {
        // works on most browsers           works on IE10/11 and Surface
        let win:any = window;
        return 'ontouchstart' in window || !!win.navigator.maxTouchPoints;
    }

    private getPlatform(): Platform {
        if (!cordova && !electron) { return Platform.Browser; }

        if (cordova) { return Platform.Cordova; }
        if (electron) { return Platform.Electron; }

        return Platform.Unknown;
    }

    private getOS(): OS {
        if (cordova) {
            switch (cordova.platformId) {
                case "osx":
                case "macos": return OS.MacOS;
                case "android": return OS.Android;
                case "ios": return OS.iOs;
                default: return OS.Unknown;
            }
        }
    }
}

export default new DeviceUtils();